import ease from "ease-component";
import scroll from "scroll";

export default class MScroll
{
	static top(el)
	{
		scroll.top(document.querySelector('html'), el.offsetTop, {
			duration: 750,
			ease: ease.inOutSine,
		});
	}
}
